import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Lock, Loader2 } from 'lucide-react';
import Logo from '../../components/Logo';
import { adminLogin } from '../../lib/api';
import { useAdminAuth } from '../../lib/AdminAuthContext';

export default function AdminLogin() {
  const navigate = useNavigate();
  const { user, login } = useAdminAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      login(res.access_token, res.email);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error de autenticación');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0d0d0e] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10"><Logo size="lg" /></div>
        <div className="gd-card p-8 md:p-10">
          <div className="flex items-center gap-3 mb-7">
            <div className="w-10 h-10 border border-[#c9a063]/40 flex items-center justify-center text-[#c9a063]"><Lock size={16} /></div>
            <div>
              <h1 className="font-serif-display text-2xl text-white">Administración</h1>
              <p className="text-white/50 text-sm">Accede a tu panel</p>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-[10px] tracking-widest text-white/50 uppercase block mb-2">Email</label>
              <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border border-white/15 text-white px-3 py-3 text-sm focus:border-[#c9a063] focus:outline-none" />
            </div>
            <div>
              <label className="text-[10px] tracking-widest text-white/50 uppercase block mb-2">Contraseña</label>
              <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-transparent border border-white/15 text-white px-3 py-3 text-sm focus:border-[#c9a063] focus:outline-none" />
            </div>
            {error && <div className="text-red-400 text-sm bg-red-500/10 border border-red-500/30 p-3">{error}</div>}
            <button disabled={loading} type="submit" className="gd-btn-gold w-full py-3.5 text-[11px] uppercase tracking-[0.3em] font-sans-ui font-medium inline-flex items-center justify-center gap-2 disabled:opacity-60">{loading ? <Loader2 size={14} className="animate-spin" /> : null} Entrar</button>
          </form>
        </div>
        <p className="text-center text-white/40 text-xs mt-6">Golf Divino · Panel de administración</p>
      </div>
    </div>
  );
}
